import { GET_DOCUMENT_OCR_STATUS } from "../common_components/case-search/services/get-document-ocr-status";
import { GET_DENIAL_HISTORY_LIST } from "../pages/analyzer/denials-predictor/services/get-denial-history-list";

export let nonLoaderActions = {
  GET_NOTIFICATIONS: true,
  GET_SYSTEM_MESSAGES: true,
  UPDATE_PREFERENCE: true,
  [GET_DOCUMENT_OCR_STATUS]: true,
  GET_DENIAL_HISTORY_LIST:true,
  REMOVE_ADJUSTMENT_CATEGORY:true,
  UPDATE_ADJUSTMENT_CATEGORY:true
};
